import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskReadyForCandidateComm_ActivityLogFragment, TaskStatus } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

// eslint-disable-next-line modernloop/restrict-imports.cjs
import { getDisplayStringForTaskStatus } from 'src/views-new/ScheduleTaskDashboard/utils';

import ActivityLogBase from '../../Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskReadyForCandidateComm_ActivityLogFragment;
}

const ActivityLogTaskReadyForCandidateComm: FCWithFragments<Fragments> = ({ activityLog }) => {
  const status = getDisplayStringForTaskStatus(TaskStatus.ReadyToSendToCandidate);

  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.setTheStatusTo"
      actionLabelValues={{ status }}
    />
  );
};

ActivityLogTaskReadyForCandidateComm.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskReadyForCandidateComm_activityLog on ActivityLog {
      id

      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskReadyForCandidateComm;
